import { useEffect, useRef, useState } from "preact/hooks";
import { listById, showError, styled } from "toucan";
import { itemById, saveUrl, setItemList } from "../model.ts";
import { go, libraryListId, noteJustSaved } from "../routes.ts";
import { store } from "../state.ts";

/** The header's Save submits this form, which is the page's only control. */
export const FORM_ID = "add-form";

const Page = styled("section")`
  padding: 1rem;
  min-height: 100%;
  /* The same warm canvas the library sits on. */
  background: var(--toucan-canvas);

  /* A pasted link is long, so the field runs the full width. */
  input {
    width: 100%;
  }
`;

/**
 * Saving one link by hand. A URL already saved opens its existing item. A
 * link saved while the library is narrowed to a list is filed on that list,
 * over any guess the save made.
 */
export function AddPage() {
  const [url, setUrl] = useState("");
  const field = useRef<HTMLInputElement>(null);
  // Focus the field on opening, so the page is one paste from a save.
  useEffect(() => {
    field.current?.focus();
  }, []);
  return (
    <Page className="page-column">
      <form
        id={FORM_ID}
        onSubmit={(event) => {
          event.preventDefault();
          const saved = saveUrl(store(), url, Date.now());
          if (saved === null) {
            showError("That does not look like a web address.");
            return;
          }
          if (saved.created) {
            const listId = libraryListId();
            const created = itemById(store(), saved.id);
            if (
              created !== undefined &&
              listId !== undefined &&
              listById(store().lists, listId) !== undefined
            ) {
              setItemList(created, listId);
            }
            noteJustSaved(saved.id);
          }
          go(`edit/${saved.id}`);
        }}
      >
        <label>
          Link
          {/* Text rather than `type="url"`: the browser's own check turns
              away an address pasted without its scheme, which the save reads
              as https. The keyboard is still the address one. */}
          <input
            ref={field}
            type="text"
            inputMode="url"
            name="url"
            placeholder="https://… (return to save)"
            value={url}
            /* The phone should not capitalise, correct or complete a link. */
            autocapitalize="off"
            autocorrect="off"
            spellcheck={false}
            required
            onInput={(event) => {
              setUrl(event.currentTarget.value);
            }}
          />
        </label>
      </form>
    </Page>
  );
}
